export enum CountryCodes {
  'United States' = 'US',
  'United Kingdom' = 'GB',
  'Hong Kong' = 'HK',
  'Japan' = 'JP',
  'Australia' = 'AU',
}

export interface Country {
  code: string;
  mapSettings: {
    center: { lat: number; lng: number };
    defaultZipCode?: string;
  };
  mask: string;
  maskExpression: string;
  name: string;
  phoneCode: string;
}

export const DEFAULT_COUNTRY: Country = {
  code: CountryCodes['United States'],
  mapSettings: {
    center: { lat: 45, lng: -98 },
  },
  mask: '(000) 000-0000',
  maskExpression: '(___) ___-____',
  name: 'United States',
  phoneCode: '+1',
};

export const COUNTRY_LIST: Country[] = [
  {
    code: 'AF',
    mapSettings: {
      center: { lat: 33, lng: 65 },
    },
    mask: '00 000 0000',
    maskExpression: '__ ___ ____',
    name: 'Afghanistan',
    phoneCode: '+93',
  },
  {
    code: 'AX',
    mapSettings: {
      center: { lat: 60.116667, lng: 19.9 },
    },
    mask: '00 0000000',
    maskExpression: '__ _______',
    name: 'Åland Islands',
    phoneCode: '+358',
  },
  {
    code: 'AL',
    mapSettings: {
      center: { lat: 41, lng: 20 },
    },
    mask: '00 000 0000',
    maskExpression: '__ ___ ____',
    name: 'Albania',
    phoneCode: '+355',
  },
  {
    code: 'DZ',
    mapSettings: {
      center: { lat: 28, lng: 3 },
    },
    mask: '000 00 00 00',
    maskExpression: '___ __ __ __',
    name: 'Algeria',
    phoneCode: '+213',
  },
  {
    code: 'AS',
    mapSettings: {
      center: { lat: -14.33333333, lng: -170 },
    },
    mask: '000 000 0000',
    maskExpression: '___ ___ ____',
    name: 'American Samoa',
    phoneCode: '+1',
  },
  {
    code: 'AD',
    mapSettings: {
      center: { lat: 42.5, lng: 1.5 },
    },
    mask: '000 000',
    maskExpression: '___ ___',
    name: 'Andorra',
    phoneCode: '+376',
  },
  {
    code: 'AO',
    mapSettings: {
      center: { lat: -12.5, lng: 18.5 },
    },
    mask: '000 000 000',
    maskExpression: '___ ___ ___',
    name: 'Angola',
    phoneCode: '+244',
  },
  {
    code: 'AI',
    mapSettings: {
      center: { lat: 18.25, lng: -63.16666666 },
    },
    mask: '000 000 0000',
    maskExpression: '___ ___ ____',
    name: 'Anguilla',
    phoneCode: '+1',
  },
  {
    code: 'AG',
    mapSettings: {
      center: { lat: 17.05, lng: -61.8 },
    },
    mask: '000 000 0000',
    maskExpression: '___ ___ ____',
    name: 'Antigua and Barbuda',
    phoneCode: '+1',
  },
  {
    code: 'AR',
    mapSettings: {
      center: { lat: -34, lng: -64 },
    },
    mask: '0 00 0000 0000',
    maskExpression: '_ __ ____ ____',
    name: 'Argentina',
    phoneCode: '+54',
  },
  {
    code: 'AM',
    mapSettings: {
      center: { lat: 40, lng: 45 },
    },
    mask: '00 000000',
    maskExpression: '__ ______',
    name: 'Armenia',
    phoneCode: '+374',
  },
  {
    code: 'AW',
    mapSettings: {
      center: { lat: 12.5, lng: -69.96666666 },
    },
    mask: '000 0000',
    maskExpression: '___ ____',
    name: 'Aruba',
    phoneCode: '+297',
  },
  {
    code: 'AU',
    mapSettings: {
      center: { lat: -23.449842, lng: 131.772449 },
    },
    mask: '(00) 0000 0000',
    maskExpression: '(__) ____ ____',
    name: 'Australia',
    phoneCode: '+61',
  },
  {
    code: 'AT',
    mapSettings: {
      center: { lat: 47.33333333, lng: 13.33333333 },
    },
    mask: '000 000000',
    maskExpression: '___ ______',
    name: 'Austria',
    phoneCode: '+43',
  },
  {
    code: 'AZ',
    mapSettings: {
      center: { lat: 40.5, lng: 47.5 },
    },
    mask: '00 000 00 00',
    maskExpression: '__ ___ __ __',
    name: 'Azerbaijan',
    phoneCode: '+994',
  },
  {
    code: 'BS',
    mapSettings: {
      center: { lat: 24.25, lng: -76 },
    },
    mask: '000 000 0000',
    maskExpression: '___ ___ ____',
    name: 'Bahamas',
    phoneCode: '+1',
  },
  {
    code: 'BH',
    mapSettings: {
      center: { lat: 26, lng: 50.55 },
    },
    mask: '0000 0000',
    maskExpression: '____ ____',
    name: 'Bahrain',
    phoneCode: '+973',
  },
  {
    code: 'BD',
    mapSettings: {
      center: { lat: 24, lng: 90 },
    },
    mask: '0000 000000',
    maskExpression: '____ ______',
    name: 'Bangladesh',
    phoneCode: '+880',
  },
  {
    code: 'BB',
    mapSettings: {
      center: { lat: 13.16666666, lng: -59.53333333 },
    },
    mask: '000 000 0000',
    maskExpression: '___ ___ ____',
    name: 'Barbados',
    phoneCode: '+1',
  },
  {
    code: 'BY',
    mapSettings: {
      center: { lat: 53, lng: 28 },
    },
    mask: '00 000 00 00',
    maskExpression: '__ ___ __ __',
    name: 'Belarus',
    phoneCode: '+375',
  },
  {
    code: 'BE',
    mapSettings: {
      center: { lat: 50.83333333, lng: 4 },
    },
    mask: '000 00 00 00',
    maskExpression: '___ __ __ __',
    name: 'Belgium',
    phoneCode: '+32',
  },
  {
    code: 'BZ',
    mapSettings: {
      center: { lat: 17.25, lng: -88.75 },
    },
    mask: '000 0000',
    maskExpression: '___ ____',
    name: 'Belize',
    phoneCode: '+501',
  },
  {
    code: 'BJ',
    mapSettings: {
      center: { lat: 9.5, lng: 2.25 },
    },
    mask: '00 00 00 00 00',
    maskExpression: '__ __ __ __ __',
    name: 'Benin',
    phoneCode: '+229',
  },
  {
    code: 'BM',
    mapSettings: {
      center: { lat: 32.33333333, lng: -64.75 },
    },
    mask: '000 000 0000',
    maskExpression: '___ ___ ____',
    name: 'Bermuda',
    phoneCode: '+1',
  },
  {
    code: 'BT',
    mapSettings: {
      center: { lat: 27.5, lng: 90.5 },
    },
    mask: '00 00 00 00',
    maskExpression: '__ __ __ __',
    name: 'Bhutan',
    phoneCode: '+975',
  },
  {
    code: 'BO',
    mapSettings: {
      center: { lat: -17, lng: -65 },
    },
    mask: '00000000',
    maskExpression: '________',
    name: 'Bolivia',
    phoneCode: '+591',
  },
  {
    code: 'BA',
    mapSettings: {
      center: { lat: 44, lng: 18 },
    },
    mask: '00 000 000',
    maskExpression: '__ ___ ___',
    name: 'Bosnia and Herzegovina',
    phoneCode: '+387',
  },
  {
    code: 'BW',
    mapSettings: {
      center: { lat: -22, lng: 24 },
    },
    mask: '00 000 000',
    maskExpression: '__ ___ ___',
    name: 'Botswana',
    phoneCode: '+267',
  },
  {
    code: 'BR',
    mapSettings: {
      center: { lat: -10, lng: -55 },
    },
    mask: '00 00000 0000',
    maskExpression: '__ _____ ____',
    name: 'Brazil',
    phoneCode: '+55',
  },
  {
    code: 'IO',
    mapSettings: {
      center: { lat: -6, lng: 71.5 },
    },
    mask: '000 0000',
    maskExpression: '___ ____',
    name: 'British Indian Ocean Territory',
    phoneCode: '+246',
  },
  {
    code: 'VG',
    mapSettings: {
      center: { lat: 18.431383, lng: -64.62305 },
    },
    mask: '000 000 0000',
    maskExpression: '___ ___ ____',
    name: 'British Virgin Islands',
    phoneCode: '+1',
  },
  {
    code: 'BN',
    mapSettings: {
      center: { lat: 4.5, lng: 114.66666666 },
    },
    mask: '000 0000',
    maskExpression: '___ ____',
    name: 'Brunei',
    phoneCode: '+673',
  },
  {
    code: 'BG',
    mapSettings: {
      center: { lat: 43, lng: 25 },
    },
    mask: '00 000 000',
    maskExpression: '__ ___ ___',
    name: 'Bulgaria',
    phoneCode: '+359',
  },
  {
    code: 'BF',
    mapSettings: {
      center: { lat: 13, lng: -2 },
    },
    mask: '00 00 00 00',
    maskExpression: '__ __ __ __',
    name: 'Burkina Faso',
    phoneCode: '+226',
  },
  {
    code: 'BI',
    mapSettings: {
      center: { lat: -3.5, lng: 30 },
    },
    mask: '00 00 00 00',
    maskExpression: '__ __ __ __',
    name: 'Burundi',
    phoneCode: '+257',
  },
  {
    code: 'KH',
    mapSettings: {
      center: { lat: 13, lng: 105 },
    },
    mask: '00 000 000',
    maskExpression: '__ ___ ___',
    name: 'Cambodia',
    phoneCode: '+855',
  },
  {
    code: 'CM',
    mapSettings: {
      center: { lat: 6, lng: 12 },
    },
    mask: '0 00 00 00 00',
    maskExpression: '_ __ __ __ __',
    name: 'Cameroon',
    phoneCode: '+237',
  },
  {
    code: 'CA',
    mapSettings: {
      center: { lat: 60, lng: -95 },
    },
    mask: '000 000 0000',
    maskExpression: '___ ___ ____',
    name: 'Canada',
    phoneCode: '+1',
  },
  {
    code: 'CV',
    mapSettings: {
      center: { lat: 16, lng: -24 },
    },
    mask: '000 00 00',
    maskExpression: '___ __ __',
    name: 'Cape Verde',
    phoneCode: '+238',
  },
  {
    code: 'BQ',
    mapSettings: {
      center: { lat: 12.18, lng: -68.25 },
    },
    mask: '000 0000',
    maskExpression: '___ ____',
    name: 'Caribbean Netherlands',
    phoneCode: '+599',
  },
  {
    code: 'KY',
    mapSettings: {
      center: { lat: 19.5, lng: -80.5 },
    },
    mask: '000 000 0000',
    maskExpression: '___ ___ ____',
    name: 'Cayman Islands',
    phoneCode: '+1',
  },
  {
    code: 'CF',
    mapSettings: {
      center: { lat: 7, lng: 21 },
    },
    mask: '00 00 00 00',
    maskExpression: '__ __ __ __',
    name: 'Central African Republic',
    phoneCode: '+236',
  },
  {
    code: 'TD',
    mapSettings: {
      center: { lat: 15, lng: 19 },
    },
    mask: '00 00 00 00',
    maskExpression: '__ __ __ __',
    name: 'Chad',
    phoneCode: '+235',
  },
  {
    code: 'CL',
    mapSettings: {
      center: { lat: -30, lng: -71 },
    },
    mask: '0 0000 0000',
    maskExpression: '_ ____ ____',
    name: 'Chile',
    phoneCode: '+56',
  },
  {
    code: 'CN',
    mapSettings: {
      center: { lat: 35, lng: 105 },
    },
    mask: '000 0000 0000',
    maskExpression: '___ ____ ____',
    name: 'China',
    phoneCode: '+86',
  },
  {
    code: 'CX',
    mapSettings: {
      center: { lat: -10.5, lng: 105.66666666 },
    },
    mask: '000 000 000',
    maskExpression: '___ ___ ___',
    name: 'Christmas Island',
    phoneCode: '+61',
  },
  {
    code: 'CC',
    mapSettings: {
      center: { lat: -12.5, lng: 96.83333333 },
    },
    mask: '000 000 000',
    maskExpression: '___ ___ ___',
    name: 'Cocos (Keeling) Islands',
    phoneCode: '+61',
  },
  {
    code: 'CO',
    mapSettings: {
      center: { lat: 4, lng: -72 },
    },
    mask: '000 0000000',
    maskExpression: '___ _______',
    name: 'Colombia',
    phoneCode: '+57',
  },
  {
    code: 'KM',
    mapSettings: {
      center: { lat: -12.16666666, lng: 44.25 },
    },
    mask: '000 00 00',
    maskExpression: '___ __ __',
    name: 'Comoros',
    phoneCode: '+269',
  },
  {
    code: 'CK',
    mapSettings: {
      center: { lat: -21.23333333, lng: -159.76666666 },
    },
    mask: '00 000',
    maskExpression: '__ ___',
    name: 'Cook Islands',
    phoneCode: '+682',
  },
  {
    code: 'CR',
    mapSettings: {
      center: { lat: 10, lng: -84 },
    },
    mask: '0000 0000',
    maskExpression: '____ ____',
    name: 'Costa Rica',
    phoneCode: '+506',
  },
  {
    code: 'HR',
    mapSettings: {
      center: { lat: 45.16666666, lng: 15.5 },
    },
    mask: '00 000 0000',
    maskExpression: '__ ___ ____',
    name: 'Croatia',
    phoneCode: '+385',
  },
  {
    code: 'CU',
    mapSettings: {
      center: { lat: 21.5, lng: -80 },
    },
    mask: '0 0000000',
    maskExpression: '_ _______',
    name: 'Cuba',
    phoneCode: '+53',
  },
  {
    code: 'CW',
    mapSettings: {
      center: { lat: 12.116667, lng: -68.933333 },
    },
    mask: '0 000 0000',
    maskExpression: '_ ___ ____',
    name: 'Curaçao',
    phoneCode: '+599',
  },
  {
    code: 'CY',
    mapSettings: {
      center: { lat: 35, lng: 33 },
    },
    mask: '00 000000',
    maskExpression: '__ ______',
    name: 'Cyprus',
    phoneCode: '+357',
  },
  {
    code: 'CZ',
    mapSettings: {
      center: { lat: 49.75, lng: 15.5 },
    },
    mask: '000 000 000',
    maskExpression: '___ ___ ___',
    name: 'Czechia',
    phoneCode: '+420',
  },
  {
    code: 'DK',
    mapSettings: {
      center: { lat: 56, lng: 10 },
    },
    mask: '00 00 00 00',
    maskExpression: '__ __ __ __',
    name: 'Denmark',
    phoneCode: '+45',
  },
  {
    code: 'DJ',
    mapSettings: {
      center: { lat: 11.5, lng: 43 },
    },
    mask: '00 00 00 00',
    maskExpression: '__ __ __ __',
    name: 'Djibouti',
    phoneCode: '+253',
  },
  {
    code: 'DM',
    mapSettings: {
      center: { lat: 15.41666666, lng: -61.33333333 },
    },
    mask: '000 000 0000',
    maskExpression: '___ ___ ____',
    name: 'Dominica',
    phoneCode: '+1',
  },
  {
    code: 'DO',
    mapSettings: {
      center: { lat: 19, lng: -70.66666666 },
    },
    mask: '000 000 0000',
    maskExpression: '___ ___ ____',
    name: 'Dominican Republic',
    phoneCode: '+1',
  },
  {
    code: 'CD',
    mapSettings: {
      center: { lat: 0, lng: 25 },
    },
    mask: '000 000 000',
    maskExpression: '___ ___ ___',
    name: 'DR Congo',
    phoneCode: '+243',
  },
  {
    code: 'EC',
    mapSettings: {
      center: { lat: -2, lng: -77.5 },
    },
    mask: '00 000 0000',
    maskExpression: '__ ___ ____',
    name: 'Ecuador',
    phoneCode: '+593',
  },
  {
    code: 'EG',
    mapSettings: {
      center: { lat: 27, lng: 30 },
    },
    mask: '00 00000000',
    maskExpression: '__ ________',
    name: 'Egypt',
    phoneCode: '+20',
  },
  {
    code: 'SV',
    mapSettings: {
      center: { lat: 13.83333333, lng: -88.91666666 },
    },
    mask: '0000 0000',
    maskExpression: '____ ____',
    name: 'El Salvador',
    phoneCode: '+503',
  },
  {
    code: 'GQ',
    mapSettings: {
      center: { lat: 2, lng: 10 },
    },
    mask: '000 000 000',
    maskExpression: '___ ___ ___',
    name: 'Equatorial Guinea',
    phoneCode: '+240',
  },
  {
    code: 'ER',
    mapSettings: {
      center: { lat: 15, lng: 39 },
    },
    mask: '0 000 000',
    maskExpression: '_ ___ ___',
    name: 'Eritrea',
    phoneCode: '+291',
  },
  {
    code: 'EE',
    mapSettings: {
      center: { lat: 59, lng: 26 },
    },
    mask: '0000 0000',
    maskExpression: '____ ____',
    name: 'Estonia',
    phoneCode: '+372',
  },
  {
    code: 'SZ',
    mapSettings: {
      center: { lat: -26.5, lng: 31.5 },
    },
    mask: '0000 0000',
    maskExpression: '____ ____',
    name: 'Eswatini',
    phoneCode: '+268',
  },
  {
    code: 'ET',
    mapSettings: {
      center: { lat: 8, lng: 38 },
    },
    mask: '00 000 0000',
    maskExpression: '__ ___ ____',
    name: 'Ethiopia',
    phoneCode: '+251',
  },
  {
    code: 'FK',
    mapSettings: {
      center: { lat: -51.75, lng: -59 },
    },
    mask: '00000',
    maskExpression: '_____',
    name: 'Falkland Islands',
    phoneCode: '+500',
  },
  {
    code: 'FO',
    mapSettings: {
      center: { lat: 62, lng: -7 },
    },
    mask: '000000',
    maskExpression: '______',
    name: 'Faroe Islands',
    phoneCode: '+298',
  },
  {
    code: 'FJ',
    mapSettings: {
      center: { lat: -18, lng: 175 },
    },
    mask: '000 0000',
    maskExpression: '___ ____',
    name: 'Fiji',
    phoneCode: '+679',
  },
  {
    code: 'FI',
    mapSettings: {
      center: { lat: 64, lng: 26 },
    },
    mask: '00 0000000',
    maskExpression: '__ _______',
    name: 'Finland',
    phoneCode: '+358',
  },
  {
    code: 'FR',
    mapSettings: {
      center: { lat: 46, lng: 2 },
    },
    mask: '0 00 00 00 00',
    maskExpression: '_ __ __ __ __',
    name: 'France',
    phoneCode: '+33',
  },
  {
    code: 'GF',
    mapSettings: {
      center: { lat: 4, lng: -53 },
    },
    mask: '000 00 00 00',
    maskExpression: '___ __ __ __',
    name: 'French Guiana',
    phoneCode: '+594',
  },
  {
    code: 'PF',
    mapSettings: {
      center: { lat: -15, lng: -140 },
    },
    mask: '00 00 00 00',
    maskExpression: '__ __ __ __',
    name: 'French Polynesia',
    phoneCode: '+689',
  },
  {
    code: 'GA',
    mapSettings: {
      center: { lat: -1, lng: 11.75 },
    },
    mask: '00 00 00 00',
    maskExpression: '__ __ __ __',
    name: 'Gabon',
    phoneCode: '+241',
  },
  {
    code: 'GM',
    mapSettings: {
      center: { lat: 13.46666666, lng: -16.56666666 },
    },
    mask: '000 0000',
    maskExpression: '___ ____',
    name: 'Gambia',
    phoneCode: '+220',
  },
  {
    code: 'GE',
    mapSettings: {
      center: { lat: 42, lng: 43.5 },
    },
    mask: '000 00 00 00',
    maskExpression: '___ __ __ __',
    name: 'Georgia',
    phoneCode: '+995',
  },
  {
    code: 'DE',
    mapSettings: {
      center: { lat: 51, lng: 9 },
    },
    mask: '0000 0000000',
    maskExpression: '____ _______',
    name: 'Germany',
    phoneCode: '+49',
  },
  {
    code: 'GH',
    mapSettings: {
      center: { lat: 8, lng: -2 },
    },
    mask: '00 000 0000',
    maskExpression: '__ ___ ____',
    name: 'Ghana',
    phoneCode: '+233',
  },
  {
    code: 'GI',
    mapSettings: {
      center: { lat: 36.13333333, lng: -5.35 },
    },
    mask: '00000000',
    maskExpression: '________',
    name: 'Gibraltar',
    phoneCode: '+350',
  },
  {
    code: 'GR',
    mapSettings: {
      center: { lat: 39, lng: 22 },
    },
    mask: '000 000 0000',
    maskExpression: '___ ___ ____',
    name: 'Greece',
    phoneCode: '+30',
  },
  {
    code: 'GL',
    mapSettings: {
      center: { lat: 72, lng: -40 },
    },
    mask: '00 00 00',
    maskExpression: '__ __ __',
    name: 'Greenland',
    phoneCode: '+299',
  },
  {
    code: 'GD',
    mapSettings: {
      center: { lat: 12.11666666, lng: -61.66666666 },
    },
    mask: '000 000 0000',
    maskExpression: '___ ___ ____',
    name: 'Grenada',
    phoneCode: '+1',
  },
  {
    code: 'GP',
    mapSettings: {
      center: { lat: 16.25, lng: -61.583333 },
    },
    mask: '000 00 00 00',
    maskExpression: '___ __ __ __',
    name: 'Guadeloupe',
    phoneCode: '+590',
  },
  {
    code: 'GU',
    mapSettings: {
      center: { lat: 13.46666666, lng: 144.78333333 },
    },
    mask: '000 000 0000',
    maskExpression: '___ ___ ____',
    name: 'Guam',
    phoneCode: '+1',
  },
  {
    code: 'GT',
    mapSettings: {
      center: { lat: 15.5, lng: -90.25 },
    },
    mask: '0000 0000',
    maskExpression: '____ ____',
    name: 'Guatemala',
    phoneCode: '+502',
  },
  {
    code: 'GG',
    mapSettings: {
      center: { lat: 49.46666666, lng: -2.58333333 },
    },
    mask: '0000 000000',
    maskExpression: '____ ______',
    name: 'Guernsey',
    phoneCode: '+44',
  },
  {
    code: 'GN',
    mapSettings: {
      center: { lat: 11, lng: -10 },
    },
    mask: '000 00 00 00',
    maskExpression: '___ __ __ __',
    name: 'Guinea',
    phoneCode: '+224',
  },
  {
    code: 'GW',
    mapSettings: {
      center: { lat: 12, lng: -15 },
    },
    mask: '000 000 000',
    maskExpression: '___ ___ ___',
    name: 'Guinea-Bissau',
    phoneCode: '+245',
  },
  {
    code: 'GY',
    mapSettings: {
      center: { lat: 5, lng: -59 },
    },
    mask: '000 0000',
    maskExpression: '___ ____',
    name: 'Guyana',
    phoneCode: '+592',
  },
  {
    code: 'HT',
    mapSettings: {
      center: { lat: 19, lng: -72.41666666 },
    },
    mask: '00 00 0000',
    maskExpression: '__ __ ____',
    name: 'Haiti',
    phoneCode: '+509',
  },
  {
    code: 'HN',
    mapSettings: {
      center: { lat: 15, lng: -86.5 },
    },
    mask: '0000 0000',
    maskExpression: '____ ____',
    name: 'Honduras',
    phoneCode: '+504',
  },
  {
    code: 'HK',
    mapSettings: {
      center: { lat: 22.316365, lng: 114.169121 },
      defaultZipCode: '999077',
    },
    mask: '0000 0000',
    maskExpression: '____ ____',
    name: 'Hong Kong',
    phoneCode: '+852',
  },
  {
    code: 'HU',
    mapSettings: {
      center: { lat: 47, lng: 20 },
    },
    mask: '00 000 0000',
    maskExpression: '__ ___ ____',
    name: 'Hungary',
    phoneCode: '+36',
  },
  {
    code: 'IS',
    mapSettings: {
      center: { lat: 65, lng: -18 },
    },
    mask: '000 0000',
    maskExpression: '___ ____',
    name: 'Iceland',
    phoneCode: '+354',
  },
  {
    code: 'IN',
    mapSettings: {
      center: { lat: 20, lng: 77 },
    },
    mask: '00000 00000',
    maskExpression: '_____ _____',
    name: 'India',
    phoneCode: '+91',
  },
  {
    code: 'ID',
    mapSettings: {
      center: { lat: -5, lng: 120 },
    },
    mask: '000 000 000',
    maskExpression: '___ ___ ___',
    name: 'Indonesia',
    phoneCode: '+62',
  },
  {
    code: 'IR',
    mapSettings: {
      center: { lat: 32, lng: 53 },
    },
    mask: '000 000 0000',
    maskExpression: '___ ___ ____',
    name: 'Iran',
    phoneCode: '+98',
  },
  {
    code: 'IQ',
    mapSettings: {
      center: { lat: 33, lng: 44 },
    },
    mask: '000 000 0000',
    maskExpression: '___ ___ ____',
    name: 'Iraq',
    phoneCode: '+964',
  },
  {
    code: 'IE',
    mapSettings: {
      center: { lat: 53, lng: -8 },
    },
    mask: '00 000 0000',
    maskExpression: '__ ___ ____',
    name: 'Ireland',
    phoneCode: '+353',
  },
  {
    code: 'IM',
    mapSettings: {
      center: { lat: 54.25, lng: -4.5 },
    },
    mask: '0000 000000',
    maskExpression: '____ ______',
    name: 'Isle of Man',
    phoneCode: '+44',
  },
  {
    code: 'IL',
    mapSettings: {
      center: { lat: 31.47, lng: 35.13 },
    },
    mask: '00 000 0000',
    maskExpression: '__ ___ ____',
    name: 'Israel',
    phoneCode: '+972',
  },
  {
    code: 'IT',
    mapSettings: {
      center: { lat: 42.83333333, lng: 12.83333333 },
    },
    mask: '000 000 0000',
    maskExpression: '___ ___ ____',
    name: 'Italy',
    phoneCode: '+39',
  },
  {
    code: 'CI',
    mapSettings: {
      center: { lat: 8, lng: -5 },
    },
    mask: '00 00 00 0000',
    maskExpression: '__ __ __ ____',
    name: 'Ivory Coast',
    phoneCode: '+225',
  },
  {
    code: 'JM',
    mapSettings: {
      center: { lat: 18.25, lng: -77.5 },
    },
    mask: '000 000 0000',
    maskExpression: '___ ___ ____',
    name: 'Jamaica',
    phoneCode: '+1',
  },
  {
    code: 'JP',
    mapSettings: {
      center: { lat: 35.789055, lng: 138.465512 },
    },
    mask: '00-0000-0000',
    maskExpression: '__-____-____',
    name: 'Japan',
    phoneCode: '+81',
  },
  {
    code: 'JE',
    mapSettings: {
      center: { lat: 49.25, lng: -2.16666666 },
    },
    mask: '0000 000000',
    maskExpression: '____ ______',
    name: 'Jersey',
    phoneCode: '+44',
  },
  {
    code: 'JO',
    mapSettings: {
      center: { lat: 31, lng: 36 },
    },
    mask: '0 0000 0000',
    maskExpression: '_ ____ ____',
    name: 'Jordan',
    phoneCode: '+962',
  },
  {
    code: 'KZ',
    mapSettings: {
      center: { lat: 48, lng: 68 },
    },
    mask: '000 000 0000',
    maskExpression: '___ ___ ____',
    name: 'Kazakhstan',
    phoneCode: '+7',
  },
  {
    code: 'KE',
    mapSettings: {
      center: { lat: 1, lng: 38 },
    },
    mask: '000 000000',
    maskExpression: '___ ______',
    name: 'Kenya',
    phoneCode: '+254',
  },
  {
    code: 'KI',
    mapSettings: {
      center: { lat: 1.41666666, lng: 173 },
    },
    mask: '00000000',
    maskExpression: '________',
    name: 'Kiribati',
    phoneCode: '+686',
  },
  {
    code: 'XK',
    mapSettings: {
      center: { lat: 42.666667, lng: 21.166667 },
    },
    mask: '00 000 000',
    maskExpression: '__ ___ ___',
    name: 'Kosovo',
    phoneCode: '+383',
  },
  {
    code: 'KW',
    mapSettings: {
      center: { lat: 29.5, lng: 45.75 },
    },
    mask: '000 00000',
    maskExpression: '___ _____',
    name: 'Kuwait',
    phoneCode: '+965',
  },
  {
    code: 'KG',
    mapSettings: {
      center: { lat: 41, lng: 75 },
    },
    mask: '000 000 000',
    maskExpression: '___ ___ ___',
    name: 'Kyrgyzstan',
    phoneCode: '+996',
  },
  {
    code: 'LA',
    mapSettings: {
      center: { lat: 18, lng: 105 },
    },
    mask: '00 00 000 000',
    maskExpression: '__ __ ___ ___',
    name: 'Laos',
    phoneCode: '+856',
  },
  {
    code: 'LV',
    mapSettings: {
      center: { lat: 57, lng: 25 },
    },
    mask: '00 000 000',
    maskExpression: '__ ___ ___',
    name: 'Latvia',
    phoneCode: '+371',
  },
  {
    code: 'LB',
    mapSettings: {
      center: { lat: 33.83333333, lng: 35.83333333 },
    },
    mask: '00 000 000',
    maskExpression: '__ ___ ___',
    name: 'Lebanon',
    phoneCode: '+961',
  },
  {
    code: 'LS',
    mapSettings: {
      center: { lat: -29.5, lng: 28.5 },
    },
    mask: '0000 0000',
    maskExpression: '____ ____',
    name: 'Lesotho',
    phoneCode: '+266',
  },
  {
    code: 'LR',
    mapSettings: {
      center: { lat: 6.5, lng: -9.5 },
    },
    mask: '00 000 0000',
    maskExpression: '__ ___ ____',
    name: 'Liberia',
    phoneCode: '+231',
  },
  {
    code: 'LY',
    mapSettings: {
      center: { lat: 25, lng: 17 },
    },
    mask: '00 0000000',
    maskExpression: '__ _______',
    name: 'Libya',
    phoneCode: '+218',
  },
  {
    code: 'LI',
    mapSettings: {
      center: { lat: 47.26666666, lng: 9.53333333 },
    },
    mask: '000 000 000',
    maskExpression: '___ ___ ___',
    name: 'Liechtenstein',
    phoneCode: '+423',
  },
  {
    code: 'LT',
    mapSettings: {
      center: { lat: 56, lng: 24 },
    },
    mask: '000 00000',
    maskExpression: '___ _____',
    name: 'Lithuania',
    phoneCode: '+370',
  },
  {
    code: 'LU',
    mapSettings: {
      center: { lat: 49.75, lng: 6.16666666 },
    },
    mask: '000 000 000',
    maskExpression: '___ ___ ___',
    name: 'Luxembourg',
    phoneCode: '+352',
  },
  {
    code: 'MO',
    mapSettings: {
      center: { lat: 22.16666666, lng: 113.55 },
    },
    mask: '0000 0000',
    maskExpression: '____ ____',
    name: 'Macau',
    phoneCode: '+853',
  },
  {
    code: 'MG',
    mapSettings: {
      center: { lat: -20, lng: 47 },
    },
    mask: '00 00 000 00',
    maskExpression: '__ __ ___ __',
    name: 'Madagascar',
    phoneCode: '+261',
  },
  {
    code: 'MW',
    mapSettings: {
      center: { lat: -13.5, lng: 34 },
    },
    mask: '000 00 00 00',
    maskExpression: '___ __ __ __',
    name: 'Malawi',
    phoneCode: '+265',
  },
  {
    code: 'MY',
    mapSettings: {
      center: { lat: 2.5, lng: 112.5 },
    },
    mask: '00 000 0000',
    maskExpression: '__ ___ ____',
    name: 'Malaysia',
    phoneCode: '+60',
  },
  {
    code: 'MV',
    mapSettings: {
      center: { lat: 3.25, lng: 73 },
    },
    mask: '000 0000',
    maskExpression: '___ ____',
    name: 'Maldives',
    phoneCode: '+960',
  },
  {
    code: 'ML',
    mapSettings: {
      center: { lat: 17, lng: -4 },
    },
    mask: '00 00 00 00',
    maskExpression: '__ __ __ __',
    name: 'Mali',
    phoneCode: '+223',
  },
  {
    code: 'MT',
    mapSettings: {
      center: { lat: 35.83333333, lng: 14.58333333 },
    },
    mask: '0000 0000',
    maskExpression: '____ ____',
    name: 'Malta',
    phoneCode: '+356',
  },
  {
    code: 'MH',
    mapSettings: {
      center: { lat: 9, lng: 168 },
    },
    mask: '000 0000',
    maskExpression: '___ ____',
    name: 'Marshall Islands',
    phoneCode: '+692',
  },
  {
    code: 'MQ',
    mapSettings: {
      center: { lat: 14.666667, lng: -61 },
    },
    mask: '000 00 00 00',
    maskExpression: '___ __ __ __',
    name: 'Martinique',
    phoneCode: '+596',
  },
  {
    code: 'MR',
    mapSettings: {
      center: { lat: 20, lng: -12 },
    },
    mask: '00 00 00 00',
    maskExpression: '__ __ __ __',
    name: 'Mauritania',
    phoneCode: '+222',
  },
  {
    code: 'MU',
    mapSettings: {
      center: { lat: -20.28333333, lng: 57.55 },
    },
    mask: '0000 0000',
    maskExpression: '____ ____',
    name: 'Mauritius',
    phoneCode: '+230',
  },
  {
    code: 'YT',
    mapSettings: {
      center: { lat: -12.83333333, lng: 45.16666666 },
    },
    mask: '000 00 00 00',
    maskExpression: '___ __ __ __',
    name: 'Mayotte',
    phoneCode: '+262',
  },
  {
    code: 'MX',
    mapSettings: {
      center: { lat: 23, lng: -102 },
    },
    mask: '000 000 0000',
    maskExpression: '___ ___ ____',
    name: 'Mexico',
    phoneCode: '+52',
  },
  {
    code: 'FM',
    mapSettings: {
      center: { lat: 6.91666666, lng: 158.25 },
    },
    mask: '000 0000',
    maskExpression: '___ ____',
    name: 'Micronesia',
    phoneCode: '+691',
  },
  {
    code: 'MD',
    mapSettings: {
      center: { lat: 47, lng: 29 },
    },
    mask: '000 00 000',
    maskExpression: '___ __ ___',
    name: 'Moldova',
    phoneCode: '+373',
  },
  {
    code: 'MC',
    mapSettings: {
      center: { lat: 43.73333333, lng: 7.4 },
    },
    mask: '0 00 00 00 00',
    maskExpression: '_ __ __ __ __',
    name: 'Monaco',
    phoneCode: '+377',
  },
  {
    code: 'MN',
    mapSettings: {
      center: { lat: 46, lng: 105 },
    },
    mask: '0000 0000',
    maskExpression: '____ ____',
    name: 'Mongolia',
    phoneCode: '+976',
  },
  {
    code: 'ME',
    mapSettings: {
      center: { lat: 42.5, lng: 19.3 },
    },
    mask: '00 000 000',
    maskExpression: '__ ___ ___',
    name: 'Montenegro',
    phoneCode: '+382',
  },
  {
    code: 'MS',
    mapSettings: {
      center: { lat: 16.75, lng: -62.2 },
    },
    mask: '000 000 0000',
    maskExpression: '___ ___ ____',
    name: 'Montserrat',
    phoneCode: '+1',
  },
  {
    code: 'MA',
    mapSettings: {
      center: { lat: 32, lng: -5 },
    },
    mask: '0 00 00 00 00',
    maskExpression: '_ __ __ __ __',
    name: 'Morocco',
    phoneCode: '+212',
  },
  {
    code: 'MZ',
    mapSettings: {
      center: { lat: -18.25, lng: 35 },
    },
    mask: '00 000 0000',
    maskExpression: '__ ___ ____',
    name: 'Mozambique',
    phoneCode: '+258',
  },
  {
    code: 'MM',
    mapSettings: {
      center: { lat: 22, lng: 98 },
    },
    mask: '0 000 0000',
    maskExpression: '_ ___ ____',
    name: 'Myanmar',
    phoneCode: '+95',
  },
  {
    code: 'NA',
    mapSettings: {
      center: { lat: -22, lng: 17 },
    },
    mask: '00 000 0000',
    maskExpression: '__ ___ ____',
    name: 'Namibia',
    phoneCode: '+264',
  },
  {
    code: 'NR',
    mapSettings: {
      center: { lat: -0.53333333, lng: 166.91666666 },
    },
    mask: '000 0000',
    maskExpression: '___ ____',
    name: 'Nauru',
    phoneCode: '+674',
  },
  {
    code: 'NP',
    mapSettings: {
      center: { lat: 28, lng: 84 },
    },
    mask: '000 0000000',
    maskExpression: '___ _______',
    name: 'Nepal',
    phoneCode: '+977',
  },
  {
    code: 'NL',
    mapSettings: {
      center: { lat: 52.5, lng: 5.75 },
    },
    mask: '0 00000000',
    maskExpression: '_ ________',
    name: 'Netherlands',
    phoneCode: '+31',
  },
  {
    code: 'NC',
    mapSettings: {
      center: { lat: -21.5, lng: 165.5 },
    },
    mask: '00 00 00',
    maskExpression: '__ __ __',
    name: 'New Caledonia',
    phoneCode: '+687',
  },
  {
    code: 'NZ',
    mapSettings: {
      center: { lat: -41, lng: 174 },
    },
    mask: '00 000 0000',
    maskExpression: '__ ___ ____',
    name: 'New Zealand',
    phoneCode: '+64',
  },
  {
    code: 'NI',
    mapSettings: {
      center: { lat: 13, lng: -85 },
    },
    mask: '0000 0000',
    maskExpression: '____ ____',
    name: 'Nicaragua',
    phoneCode: '+505',
  },
  {
    code: 'NE',
    mapSettings: {
      center: { lat: 16, lng: 8 },
    },
    mask: '00 00 00 00',
    maskExpression: '__ __ __ __',
    name: 'Niger',
    phoneCode: '+227',
  },
  {
    code: 'NG',
    mapSettings: {
      center: { lat: 10, lng: 8 },
    },
    mask: '000 000 0000',
    maskExpression: '___ ___ ____',
    name: 'Nigeria',
    phoneCode: '+234',
  },
  {
    code: 'NU',
    mapSettings: {
      center: { lat: -19.03333333, lng: -169.86666666 },
    },
    mask: '000 0000',
    maskExpression: '___ ____',
    name: 'Niue',
    phoneCode: '+683',
  },
  {
    code: 'NF',
    mapSettings: {
      center: { lat: -29.03333333, lng: 167.95 },
    },
    mask: '0 00000',
    maskExpression: '_ _____',
    name: 'Norfolk Island',
    phoneCode: '+672',
  },
  {
    code: 'KP',
    mapSettings: {
      center: { lat: 40, lng: 127 },
    },
    mask: '000 000 0000',
    maskExpression: '___ ___ ____',
    name: 'North Korea',
    phoneCode: '+850',
  },
  {
    code: 'MK',
    mapSettings: {
      center: { lat: 41.83333333, lng: 22 },
    },
    mask: '00 000 000',
    maskExpression: '__ ___ ___',
    name: 'North Macedonia',
    phoneCode: '+389',
  },
  {
    code: 'MP',
    mapSettings: {
      center: { lat: 15.2, lng: 145.75 },
    },
    mask: '000 000 0000',
    maskExpression: '___ ___ ____',
    name: 'Northern Mariana Islands',
    phoneCode: '+1',
  },
  {
    code: 'NO',
    mapSettings: {
      center: { lat: 62, lng: 10 },
    },
    mask: '00 00 00 00',
    maskExpression: '__ __ __ __',
    name: 'Norway',
    phoneCode: '+47',
  },
  {
    code: 'OM',
    mapSettings: {
      center: { lat: 21, lng: 57 },
    },
    mask: '0000 0000',
    maskExpression: '____ ____',
    name: 'Oman',
    phoneCode: '+968',
  },
  {
    code: 'PK',
    mapSettings: {
      center: { lat: 30, lng: 70 },
    },
    mask: '000 0000000',
    maskExpression: '___ _______',
    name: 'Pakistan',
    phoneCode: '+92',
  },
  {
    code: 'PW',
    mapSettings: {
      center: { lat: 7.5, lng: 134.5 },
    },
    mask: '000 0000',
    maskExpression: '___ ____',
    name: 'Palau',
    phoneCode: '+680',
  },
  {
    code: 'PS',
    mapSettings: {
      center: { lat: 31.9, lng: 35.2 },
    },
    mask: '000 000 000',
    maskExpression: '___ ___ ___',
    name: 'Palestine',
    phoneCode: '+970',
  },
  {
    code: 'PA',
    mapSettings: {
      center: { lat: 9, lng: -80 },
    },
    mask: '0000 0000',
    maskExpression: '____ ____',
    name: 'Panama',
    phoneCode: '+507',
  },
  {
    code: 'PG',
    mapSettings: {
      center: { lat: -6, lng: 147 },
    },
    mask: '0000 0000',
    maskExpression: '____ ____',
    name: 'Papua New Guinea',
    phoneCode: '+675',
  },
  {
    code: 'PY',
    mapSettings: {
      center: { lat: -23, lng: -58 },
    },
    mask: '000 000000',
    maskExpression: '___ ______',
    name: 'Paraguay',
    phoneCode: '+595',
  },
  {
    code: 'PE',
    mapSettings: {
      center: { lat: -10, lng: -76 },
    },
    mask: '000 000 000',
    maskExpression: '___ ___ ___',
    name: 'Peru',
    phoneCode: '+51',
  },
  {
    code: 'PH',
    mapSettings: {
      center: { lat: 13, lng: 122 },
    },
    mask: '000 000 0000',
    maskExpression: '___ ___ ____',
    name: 'Philippines',
    phoneCode: '+63',
  },
  {
    code: 'PL',
    mapSettings: {
      center: { lat: 52, lng: 20 },
    },
    mask: '000 000 000',
    maskExpression: '___ ___ ___',
    name: 'Poland',
    phoneCode: '+48',
  },
  {
    code: 'PT',
    mapSettings: {
      center: { lat: 39.5, lng: -8 },
    },
    mask: '000 000 000',
    maskExpression: '___ ___ ___',
    name: 'Portugal',
    phoneCode: '+351',
  },
  {
    code: 'PR',
    mapSettings: {
      center: { lat: 18.25, lng: -66.5 },
    },
    mask: '000 000 0000',
    maskExpression: '___ ___ ____',
    name: 'Puerto Rico',
    phoneCode: '+1',
  },
  {
    code: 'QA',
    mapSettings: {
      center: { lat: 25.5, lng: 51.25 },
    },
    mask: '0000 0000',
    maskExpression: '____ ____',
    name: 'Qatar',
    phoneCode: '+974',
  },
  {
    code: 'CG',
    mapSettings: {
      center: { lat: -1, lng: 15 },
    },
    mask: '00 000 0000',
    maskExpression: '__ ___ ____',
    name: 'Republic of the Congo',
    phoneCode: '+242',
  },
  {
    code: 'RE',
    mapSettings: {
      center: { lat: -21.15, lng: 55.5 },
    },
    mask: '000 00 00 00',
    maskExpression: '___ __ __ __',
    name: 'Réunion',
    phoneCode: '+262',
  },
  {
    code: 'RO',
    mapSettings: {
      center: { lat: 46, lng: 25 },
    },
    mask: '000 000 000',
    maskExpression: '___ ___ ___',
    name: 'Romania',
    phoneCode: '+40',
  },
  {
    code: 'RU',
    mapSettings: {
      center: { lat: 60, lng: 100 },
    },
    mask: '000 000 00 00',
    maskExpression: '___ ___ __ __',
    name: 'Russia',
    phoneCode: '+7',
  },
  {
    code: 'RW',
    mapSettings: {
      center: { lat: -2, lng: 30 },
    },
    mask: '000 000 000',
    maskExpression: '___ ___ ___',
    name: 'Rwanda',
    phoneCode: '+250',
  },
  {
    code: 'BL',
    mapSettings: {
      center: { lat: 18.5, lng: -63.41666666 },
    },
    mask: '000 00 00 00',
    maskExpression: '___ __ __ __',
    name: 'Saint Barthélemy',
    phoneCode: '+590',
  },
  {
    code: 'SH',
    mapSettings: {
      center: { lat: -15.95, lng: -5.72 },
    },
    mask: '00000',
    maskExpression: '_____',
    name: 'Saint Helena, Ascension and Tristan da Cunha',
    phoneCode: '+290',
  },
  {
    code: 'KN',
    mapSettings: {
      center: { lat: 17.33333333, lng: -62.75 },
    },
    mask: '000 000 0000',
    maskExpression: '___ ___ ____',
    name: 'Saint Kitts and Nevis',
    phoneCode: '+1',
  },
  {
    code: 'LC',
    mapSettings: {
      center: { lat: 13.88333333, lng: -60.96666666 },
    },
    mask: '000 000 0000',
    maskExpression: '___ ___ ____',
    name: 'Saint Lucia',
    phoneCode: '+1',
  },
  {
    code: 'MF',
    mapSettings: {
      center: { lat: 18.08333333, lng: -63.95 },
    },
    mask: '000 00 00 00',
    maskExpression: '___ __ __ __',
    name: 'Saint Martin',
    phoneCode: '+590',
  },
  {
    code: 'PM',
    mapSettings: {
      center: { lat: 46.83333333, lng: -56.33333333 },
    },
    mask: '00 00 00',
    maskExpression: '__ __ __',
    name: 'Saint Pierre and Miquelon',
    phoneCode: '+508',
  },
  {
    code: 'VC',
    mapSettings: {
      center: { lat: 13.25, lng: -61.2 },
    },
    mask: '000 000 0000',
    maskExpression: '___ ___ ____',
    name: 'Saint Vincent and the Grenadines',
    phoneCode: '+1',
  },
  {
    code: 'WS',
    mapSettings: {
      center: { lat: -13.58333333, lng: -172.33333333 },
    },
    mask: '00 00000',
    maskExpression: '__ _____',
    name: 'Samoa',
    phoneCode: '+685',
  },
  {
    code: 'SM',
    mapSettings: {
      center: { lat: 43.76666666, lng: 12.41666666 },
    },
    mask: '00 00 00 00',
    maskExpression: '__ __ __ __',
    name: 'San Marino',
    phoneCode: '+378',
  },
  {
    code: 'ST',
    mapSettings: {
      center: { lat: 1, lng: 7 },
    },
    mask: '000 0000',
    maskExpression: '___ ____',
    name: 'São Tomé and Príncipe',
    phoneCode: '+239',
  },
  {
    code: 'SA',
    mapSettings: {
      center: { lat: 25, lng: 45 },
    },
    mask: '00 000 0000',
    maskExpression: '__ ___ ____',
    name: 'Saudi Arabia',
    phoneCode: '+966',
  },
  {
    code: 'SN',
    mapSettings: {
      center: { lat: 14, lng: -14 },
    },
    mask: '00 000 00 00',
    maskExpression: '__ ___ __ __',
    name: 'Senegal',
    phoneCode: '+221',
  },
  {
    code: 'RS',
    mapSettings: {
      center: { lat: 44, lng: 21 },
    },
    mask: '00 0000000',
    maskExpression: '__ _______',
    name: 'Serbia',
    phoneCode: '+381',
  },
  {
    code: 'SC',
    mapSettings: {
      center: { lat: -4.58333333, lng: 55.66666666 },
    },
    mask: '0 000 000',
    maskExpression: '_ ___ ___',
    name: 'Seychelles',
    phoneCode: '+248',
  },
  {
    code: 'SL',
    mapSettings: {
      center: { lat: 8.5, lng: -11.5 },
    },
    mask: '00 000000',
    maskExpression: '__ ______',
    name: 'Sierra Leone',
    phoneCode: '+232',
  },
  {
    code: 'SG',
    mapSettings: {
      center: { lat: 1.36666666, lng: 103.8 },
    },
    mask: '0000 0000',
    maskExpression: '____ ____',
    name: 'Singapore',
    phoneCode: '+65',
  },
  {
    code: 'SX',
    mapSettings: {
      center: { lat: 18.033333, lng: -63.05 },
    },
    mask: '000 000 0000',
    maskExpression: '___ ___ ____',
    name: 'Sint Maarten',
    phoneCode: '+1',
  },
  {
    code: 'SK',
    mapSettings: {
      center: { lat: 48.66666666, lng: 19.5 },
    },
    mask: '000 000 000',
    maskExpression: '___ ___ ___',
    name: 'Slovakia',
    phoneCode: '+421',
  },
  {
    code: 'SI',
    mapSettings: {
      center: { lat: 46.11666666, lng: 14.81666666 },
    },
    mask: '00 000 000',
    maskExpression: '__ ___ ___',
    name: 'Slovenia',
    phoneCode: '+386',
  },
  {
    code: 'SB',
    mapSettings: {
      center: { lat: -8, lng: 159 },
    },
    mask: '00 00000',
    maskExpression: '__ _____',
    name: 'Solomon Islands',
    phoneCode: '+677',
  },
  {
    code: 'SO',
    mapSettings: {
      center: { lat: 10, lng: 49 },
    },
    mask: '0 0000000',
    maskExpression: '_ _______',
    name: 'Somalia',
    phoneCode: '+252',
  },
  {
    code: 'ZA',
    mapSettings: {
      center: { lat: -29, lng: 24 },
    },
    mask: '00 000 0000',
    maskExpression: '__ ___ ____',
    name: 'South Africa',
    phoneCode: '+27',
  },
  {
    code: 'KR',
    mapSettings: {
      center: { lat: 37, lng: 127.5 },
    },
    mask: '00 0000 0000',
    maskExpression: '__ ____ ____',
    name: 'South Korea',
    phoneCode: '+82',
  },
  {
    code: 'SS',
    mapSettings: {
      center: { lat: 7, lng: 30 },
    },
    mask: '000 000 000',
    maskExpression: '___ ___ ___',
    name: 'South Sudan',
    phoneCode: '+211',
  },
  {
    code: 'ES',
    mapSettings: {
      center: { lat: 40, lng: -4 },
    },
    mask: '000 00 00 00',
    maskExpression: '___ __ __ __',
    name: 'Spain',
    phoneCode: '+34',
  },
  {
    code: 'LK',
    mapSettings: {
      center: { lat: 7, lng: 81 },
    },
    mask: '00 000 0000',
    maskExpression: '__ ___ ____',
    name: 'Sri Lanka',
    phoneCode: '+94',
  },
  {
    code: 'SD',
    mapSettings: {
      center: { lat: 15, lng: 30 },
    },
    mask: '00 000 0000',
    maskExpression: '__ ___ ____',
    name: 'Sudan',
    phoneCode: '+249',
  },
  {
    code: 'SR',
    mapSettings: {
      center: { lat: 4, lng: -56 },
    },
    mask: '000 0000',
    maskExpression: '___ ____',
    name: 'Suriname',
    phoneCode: '+597',
  },
  {
    code: 'SJ',
    mapSettings: {
      center: { lat: 78, lng: 20 },
    },
    mask: '00 00 00 00',
    maskExpression: '__ __ __ __',
    name: 'Svalbard and Jan Mayen',
    phoneCode: '+47',
  },
  {
    code: 'SE',
    mapSettings: {
      center: { lat: 62, lng: 15 },
    },
    mask: '00 000 00 00',
    maskExpression: '__ ___ __ __',
    name: 'Sweden',
    phoneCode: '+46',
  },
  {
    code: 'CH',
    mapSettings: {
      center: { lat: 47, lng: 8 },
    },
    mask: '00 000 00 00',
    maskExpression: '__ ___ __ __',
    name: 'Switzerland',
    phoneCode: '+41',
  },
  {
    code: 'SY',
    mapSettings: {
      center: { lat: 35, lng: 38 },
    },
    mask: '000 000 000',
    maskExpression: '___ ___ ___',
    name: 'Syria',
    phoneCode: '+963',
  },
  {
    code: 'TW',
    mapSettings: {
      center: { lat: 23.5, lng: 121 },
    },
    mask: '000 000 000',
    maskExpression: '___ ___ ___',
    name: 'Taiwan',
    phoneCode: '+886',
  },
  {
    code: 'TJ',
    mapSettings: {
      center: { lat: 39, lng: 71 },
    },
    mask: '00 000 0000',
    maskExpression: '__ ___ ____',
    name: 'Tajikistan',
    phoneCode: '+992',
  },
  {
    code: 'TZ',
    mapSettings: {
      center: { lat: -6, lng: 35 },
    },
    mask: '000 000 000',
    maskExpression: '___ ___ ___',
    name: 'Tanzania',
    phoneCode: '+255',
  },
  {
    code: 'TH',
    mapSettings: {
      center: { lat: 15, lng: 100 },
    },
    mask: '00 000 0000',
    maskExpression: '__ ___ ____',
    name: 'Thailand',
    phoneCode: '+66',
  },
  {
    code: 'TL',
    mapSettings: {
      center: { lat: -8.83333333, lng: 125.91666666 },
    },
    mask: '0000 0000',
    maskExpression: '____ ____',
    name: 'Timor-Leste',
    phoneCode: '+670',
  },
  {
    code: 'TG',
    mapSettings: {
      center: { lat: 8, lng: 1.16666666 },
    },
    mask: '00 00 00 00',
    maskExpression: '__ __ __ __',
    name: 'Togo',
    phoneCode: '+228',
  },
  {
    code: 'TK',
    mapSettings: {
      center: { lat: -9, lng: -172 },
    },
    mask: '0000',
    maskExpression: '____',
    name: 'Tokelau',
    phoneCode: '+690',
  },
  {
    code: 'TO',
    mapSettings: {
      center: { lat: -20, lng: -175 },
    },
    mask: '000 0000',
    maskExpression: '___ ____',
    name: 'Tonga',
    phoneCode: '+676',
  },
  {
    code: 'TT',
    mapSettings: {
      center: { lat: 11, lng: -61 },
    },
    mask: '000 000 0000',
    maskExpression: '___ ___ ____',
    name: 'Trinidad and Tobago',
    phoneCode: '+1',
  },
  {
    code: 'TN',
    mapSettings: {
      center: { lat: 34, lng: 9 },
    },
    mask: '00 000 000',
    maskExpression: '__ ___ ___',
    name: 'Tunisia',
    phoneCode: '+216',
  },
  {
    code: 'TR',
    mapSettings: {
      center: { lat: 39, lng: 35 },
    },
    mask: '000 000 00 00',
    maskExpression: '___ ___ __ __',
    name: 'Türkiye',
    phoneCode: '+90',
  },
  {
    code: 'TM',
    mapSettings: {
      center: { lat: 40, lng: 60 },
    },
    mask: '00 000000',
    maskExpression: '__ ______',
    name: 'Turkmenistan',
    phoneCode: '+993',
  },
  {
    code: 'TC',
    mapSettings: {
      center: { lat: 21.75, lng: -71.58333333 },
    },
    mask: '000 000 0000',
    maskExpression: '___ ___ ____',
    name: 'Turks and Caicos Islands',
    phoneCode: '+1',
  },
  {
    code: 'TV',
    mapSettings: {
      center: { lat: -8, lng: 178 },
    },
    mask: '00 0000',
    maskExpression: '__ ____',
    name: 'Tuvalu',
    phoneCode: '+688',
  },
  {
    code: 'UG',
    mapSettings: {
      center: { lat: 1, lng: 32 },
    },
    mask: '000 000000',
    maskExpression: '___ ______',
    name: 'Uganda',
    phoneCode: '+256',
  },
  {
    code: 'UA',
    mapSettings: {
      center: { lat: 49, lng: 32 },
    },
    mask: '00 000 0000',
    maskExpression: '__ ___ ____',
    name: 'Ukraine',
    phoneCode: '+380',
  },
  {
    code: 'AE',
    mapSettings: {
      center: { lat: 24, lng: 54 },
    },
    mask: '00 000 0000',
    maskExpression: '__ ___ ____',
    name: 'United Arab Emirates',
    phoneCode: '+971',
  },
  {
    code: 'GB',
    mapSettings: {
      center: { lat: 52.957308, lng: -1.988953 },
    },
    mask: '000 0000 0000',
    maskExpression: '___ ____ ____',
    name: 'United Kingdom',
    phoneCode: '+44',
  },
  {
    code: 'US',
    mapSettings: {
      center: { lat: 45, lng: -98 },
    },
    mask: '(000) 000-0000',
    maskExpression: '(___) ___-____',
    name: 'United States',
    phoneCode: '+1',
  },
  {
    code: 'VI',
    mapSettings: {
      center: { lat: 18.35, lng: -64.933333 },
    },
    mask: '000 000 0000',
    maskExpression: '___ ___ ____',
    name: 'United States Virgin Islands',
    phoneCode: '+1',
  },
  {
    code: 'UY',
    mapSettings: {
      center: { lat: -33, lng: -56 },
    },
    mask: '00 000 000',
    maskExpression: '__ ___ ___',
    name: 'Uruguay',
    phoneCode: '+598',
  },
  {
    code: 'UZ',
    mapSettings: {
      center: { lat: 41, lng: 64 },
    },
    mask: '00 000 00 00',
    maskExpression: '__ ___ __ __',
    name: 'Uzbekistan',
    phoneCode: '+998',
  },
  {
    code: 'VU',
    mapSettings: {
      center: { lat: -16, lng: 167 },
    },
    mask: '000 0000',
    maskExpression: '___ ____',
    name: 'Vanuatu',
    phoneCode: '+678',
  },
  {
    code: 'VA',
    mapSettings: {
      center: { lat: 41.9, lng: 12.45 },
    },
    mask: '000 000 0000',
    maskExpression: '___ ___ ____',
    name: 'Vatican City',
    phoneCode: '+39',
  },
  {
    code: 'VE',
    mapSettings: {
      center: { lat: 8, lng: -66 },
    },
    mask: '000 0000000',
    maskExpression: '___ _______',
    name: 'Venezuela',
    phoneCode: '+58',
  },
  {
    code: 'VN',
    mapSettings: {
      center: { lat: 16.16666666, lng: 107.83333333 },
    },
    mask: '000 000 000',
    maskExpression: '___ ___ ___',
    name: 'Vietnam',
    phoneCode: '+84',
  },
  {
    code: 'WF',
    mapSettings: {
      center: { lat: -13.3, lng: -176.2 },
    },
    mask: '00 00 00',
    maskExpression: '__ __ __',
    name: 'Wallis and Futuna',
    phoneCode: '+681',
  },
  {
    code: 'EH',
    mapSettings: {
      center: { lat: 24.5, lng: -13 },
    },
    mask: '0 00 00 00 00',
    maskExpression: '_ __ __ __ __',
    name: 'Western Sahara',
    phoneCode: '+212',
  },
  {
    code: 'YE',
    mapSettings: {
      center: { lat: 15, lng: 48 },
    },
    mask: '000 000 000',
    maskExpression: '___ ___ ___',
    name: 'Yemen',
    phoneCode: '+967',
  },
  {
    code: 'ZM',
    mapSettings: {
      center: { lat: -15, lng: 30 },
    },
    mask: '00 0000000',
    maskExpression: '__ _______',
    name: 'Zambia',
    phoneCode: '+260',
  },
  {
    code: 'ZW',
    mapSettings: {
      center: { lat: -20, lng: 30 },
    },
    mask: '00 000 0000',
    maskExpression: '__ ___ ____',
    name: 'Zimbabwe',
    phoneCode: '+263',
  },
];
